import { FilterChip } from '@marqvision/shared';
import { MarqCommonEnumsAiClientTagEnum } from '~/swagger/data-contracts';
import { useLogger } from '~/hooks';
import { getListingTabGroup } from '~/utils';
import { ResponsiveProps } from '~/components/Responsive/@types';
import { useGetFilterParams, usePathParams } from './@hooks';
import { TAG_FILTER_LABEL } from './@constants';

export const RepeatOffenderFilter = (props: ResponsiveProps) => {
  const { size = 'medium' } = props;
  const { requestFilterParams, setParams } = useGetFilterParams();
  const { repeat_offender_filter: repeatOffender } = requestFilterParams;
  const { page, listingStatus } = usePathParams();

  const { amplitudeLogging } = useLogger();
  const handleChange = () => {
    const newState = !repeatOffender;
    if (newState) {
      amplitudeLogging('applied filter', {
        Type: 'repeat offender',
        Channel: page, // marketplace, social media..
        Page: getListingTabGroup(listingStatus), // scanned, flagged, in progress, case closed, test purchase
      });
    }
    setParams({
      repeat_offender: newState,
    });
  };

  return (
    <FilterChip
      size={size}
      type="toggle"
      selected={!!repeatOffender}
      label={TAG_FILTER_LABEL[MarqCommonEnumsAiClientTagEnum.RepeatOffender]}
      onClick={handleChange}
    />
  );
};
